<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "AnchorsApp",
    data() {
        return {
            hash: window.location.hash.substring(1),
            city: null,
            opened: false,
            cities: [],
        };
    },
    methods: {
        scrollTo(hash, noReplaceHash) {
            // const id = _.camelCase(hash.trim());
            const id = hash.trim();
            const navHeight = document
                .querySelector("nav")
                .getBoundingClientRect().height;
            const element = document.getElementById(id);

            if (typeof noReplaceHash === "undefined" || noReplaceHash === false)
                window.location.hash = "#" + hash;

            if (element === null) return;

            window.scrollTo({
                top: element.offsetTop - 185,
                left: 0,
                behavior: "smooth",
            });
        },
    },
    mounted() {
        this.$parent.scrollTo = this.scrollTo;

        if (this.hash !== "") {
            setTimeout(() => {
                this.scrollTo(this.hash, true);
            }, 800);
        }
    },
};
</script>
